import { combineReducers } from '@reduxjs/toolkit';

import customMetaTags from './customMetaTags/slice';
import metaTags from './metaTags/slice';

export default combineReducers({
  metaTags,
  customMetaTags,
});
